import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settings: {},
  loading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    fetchSettingsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSettingsSuccess: (state, action) => {
      state.loading = false;
      state.settings = action.payload;
    },
    fetchSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateSetting: (state, action) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    clearSettings: (state) => {
      state.settings = {};
    },
  },
});

export const {
  fetchSettingsStart,
  fetchSettingsSuccess,
  fetchSettingsFailure,
  updateSetting,
  clearSettings,
} = settingsSlice.actions;

export const selectSettings = (state) => state.settings.settings;
export const selectSettingsLoading = (state) => state.settings.loading;
export const selectSettingsError = (state) => state.settings.error;

export const fetchSettings = () => async (dispatch, getState) => {
  const token = getState().user.user?.token;

  dispatch(fetchSettingsStart());

  try {
    const res = await fetch(`${process.env.REACT_APP_MAIN_URL}/api/settings`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    const data = await res.json();

    if (data.success === 1) {
      dispatch(fetchSettingsSuccess(data.data));
    } else {
      dispatch(fetchSettingsFailure("Failed to fetch settings"));
    }
  } catch (err) {
    dispatch(fetchSettingsFailure(err.message));
  }
};

export default settingsSlice.reducer;